<template>
  <div class="activitylist">
    <template>
      <div class="list_item">
		  <div class="main_title">
		  	<div class="img"></div>
		  	<div class="title">{{this.item.name}}</div>
			 <div class="tips">
				 <div @click="toPath">抽奖规则</div>
			 </div>
		  </div>
		  <div class="line"></div>
		  <div v-if="this.item.begin_time" class="info-content-left">
		  	<span>开始时间：</span>
			<span>{{this.item.begin_time}}</span>
		  </div>
		  <div v-if="this.item.end_time" class="info-content-left">
		  	<span>结束时间：</span>
			<span>{{this.item.end_time}}</span>
		  </div>
      </div>
	  <div v-if="this.item.winner_list.length > 0">
	  <div class="person_main">
	  	<div class="person_title">中奖名单</div>
	  </div>
	  <div class="person_line"></div>
	  <div class="person_list_item" v-for="(item, i) in this.item.winner_list" :key="i">
		  <div class="person_content">{{item.user_phone+'抽中了'+item.activity_prize_name}}
		  </div>
	  </div>
	 </div>
    </template>
   <!-- <van-empty
      v-else
      class="custom-image"
      image="https://img01.yzcdn.cn/vant/custom-empty-image.png"
      description="暂无历史活动哦~"
    /> -->
  </div>
</template>

<script>
// import { getNextActivityList } from "@/api/draw.js";
import { getHistoryActivityList } from "@/api/draw.js"
export default {
  data() {
    return {
      list: [],
      item: null,
    };
  },
  created() {
   this.item = JSON.parse(this.$route.query.item);
   console.log(this.item);
    // this.getList();
  },
  methods:{
	  toPath() {
		  this.$router.push({ path: "/DrawRule",query:{item:this.item,type:2} });
		  }
	  },
};
</script>
<style lang="scss" scoped>
/deep/ .custom-image .van-empty__image {
  width: 90px;
  height: 90px;
}
div {
  box-sizing: border-box;
}
img {
  width: 100%;
  height: 100%;
}
.activitylist {
  width: 100%;
  height: 100%;
  padding: 10px 13px;
  background-color: #f6f6f6;
  .person_main{
	background-color: #fcfcfc;
	border-radius: 8px;
	padding: 17px 0px;
	.person_title{
		margin-left: 16px;
		width: 100%;
		text-align: left;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #333333;
	}
  }
  .person_line{
  	background-color: #EEEEEE;
  	width: 100%;
  	height: 0.5px;
  }
  .person_list_item {
    width: 100%;
    height: 30px;
    background-color: #fcfcfc;
    // display: flex;
    // align-items: center;
    justify-content: space-between;
    padding: 10px;
  	//  每一行的信息
  	.person_content{
  		// margin: 15px 0;
  		font-size: 14px;
  		font-family: PingFang SC;
  		font-weight: 500;
  		color: #333333;
  		text-align: left;
  	}
  }
  .list_item {
    margin-top: 10px;
    width: 100%;
    border-radius: 8px;
    // height: 111px;
    background-color: #fcfcfc;
    // display: flex;
    // align-items: center;
    justify-content: space-between;
    // padding: 10px;
	.main_title{
		display: flex;
		padding: 17px 0px;
		.img {
		  width: 2px;
		  height: 16px;
		  background-color: #017FD9;
		  // border-radius: 4px;
		  // overflow: hidden;
		}
		.title{
			margin-left: 16px;
			width: 320px;
			text-align: left;
			font-size: 16px;
			font-family: PingFang SC;
			font-weight: 500;
			color: #333333;
		}
		.tips {
		  width: 65px;
		  position: fixed;
		  top: 12px;
		  right: 13px;
		  font-size: 12px;
		  text-align: center;
		  font-family: PingFang SC;
		  font-weight: 500;
		  color: #eeeeee;
		  div {
		    height: 25px;
		    line-height: 25px;
		    background: rgba($color: #1ca1fa, $alpha: 1);
		    border-radius: 12.5px 0 0 12.5px;
		    &:last-child {
		      margin-top: 9px;
		    }
		  }
			}
	}
	.line{
		background-color: #EEEEEE;
		width: 100%;
		height: 0.5px;
	}
   
	// .beginDate{
	// 	margin-left: 16px;
	// 	width: 100%;
	// 	text-align: left;
	// 	font-size: 14px;
	// 	font-family: PingFang SC;
	// 	font-weight: 500;
	// 	color: #999999;
	// }
	//  每一行的信息
	.person_content{
		margin: 10px 0;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #333333;
		text-align: left;
	}
	.info-content-left {
	  position: relative;
	  margin: 10px 0;
	  text-align: left;
	  font-size: 14px;
	  font-family: PingFang SC;
	  font-weight: 500;
	  span {
	    &:first-child {
	      display: inline-block;
	      width: 85px;
	      padding: 5px;
	      box-sizing: border-box;
	      color: #999999;
	    }
	    &:last-child {
	      display: inline-block;
	      width: 203px;
	      color: #333333;
	      // margin-left: 5px;
	    }
	  }
	  // 问题描述
	  .more-title {
	    display: inline-block;
	    width: 85px;
	    padding: 5px;
	    position: absolute;
	  }
	  .more-content {
		padding: 5px 0px;
	    margin-left: 85px !important;
	  }
 
    }
  }
}
</style>
<style>
.van-empty {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  transition: transform 0.3s;
}
.van-empty__description {
  width: 100%;
}
</style>
